import React, { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Form,
  Input,
  notification,
  Select,
  Switch,
  Typography,
} from "antd";
import { get, post } from "../../../api/axios";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ImagesUploadComponent from "../../control-sections/helper/ImagesUploadComponent";

const { Title } = Typography;

const { Panel } = Collapse;
const AddListings = () => {
  const navigate = useNavigate();

  // STATES
  const [loading, setLoading] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [propertyTypeOptions, setPropertyTypeOptions] = useState([]);
  const [listingTypeOptions, setListingTypeOptions] = useState([]);

  // HANDLERS
  const handleImageUpload = (imageUrl) => {
    setImageList((prev) => [...prev, imageUrl]);
  };

  // SUBMITTERS
  const onFinish = (values) => {
    setLoading(true);
    if (!imageList.length) {
      notification.error({
        message: "Missing required images",
        description: "Please upload at least one image.",
      });
      setLoading(false);
      return;
    }
    const data = {
      ...values,
      images: imageList.map((image) => image.path || image.url),
    };

    data.is_furnished = data.is_furnished ? 1 : 0;
    data.is_active = data.is_active ? 1 : 0;
    data.is_approved = data.is_approved ? 1 : 0;

    post("listings", data)
      .then((res) => {
        notification.success({ message: "Added successfully" });
        setLoading(false);
        navigate("/listings");
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response?.data?.message || "Something went wrong.",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    const getSellers = () => {
      get("sellers").then((res) => {
        setSellerOptions(
          res.data.data.map((seller) => ({
            value: seller.id,
            label: seller.name,
          }))
        );
      });
    };

    const getTypes = () => {
      get("get-types").then((res) => {
        setPropertyTypeOptions(
          res?.data?.property_types
            ? res?.data?.property_types.map((propertyType) => ({
                label: propertyType.value,
                value : propertyType.key,
              }))
            : []
        );
        setListingTypeOptions(
          res?.data?.listing_types
            ? res?.data?.listing_types.map((listingType) => ({
                label: listingType.value,
                value : listingType.key,
              }))
            : []
        );
      });
    };

    getSellers();
    getTypes();
  }, []);

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        <Link className="text-dark me-3" to="/listings">
          <ArrowLeftOutlined />
        </Link>
        Add Listings
      </Title>
      <Form
        className="wrapper-content"
        onFinish={onFinish}
        labelCol={{
          span: 7,
        }}
        wrapperCol={{
          span: 15,
        }}
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
      >
        <div className="row">
          <div className="row">
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Price"
                name="price"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Area"
                name="area"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Location"
                name="location"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Floor"
                name="floor"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Rooms"
                name="rooms"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Bathrooms"
                name="bathrooms"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Description"
                name="description"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Youtube Link"
                name="youtube_link"
                rules={[
                  {
                    pattern:
                      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/,
                    message: "Please enter a valid YouTube link!",
                  },
                ]}
              >
                <Input placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="License Number"
                name="rega_ad_license_number"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "License number must be exactly 10 digits!",
                  },
                ]}
              >
                <Input type="number" placeholder="Type..." />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Seller"
                name="seller_id"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  placeholder="select..."
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={sellerOptions}
                />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Property Type"
                name="property_type"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  placeholder="select..."
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={() => {}}
                  options={propertyTypeOptions}
                />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item
                label="Listing Type"
                name="listing_type"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  placeholder="select..."
                  optionFilterProp="children"
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={() => {}}
                  options={listingTypeOptions}
                />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item label="Furnished" name="is_furnished">
                <Switch defaultChecked={false} />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item label="Active" name="is_active">
                <Switch defaultChecked={false} />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-6">
              <Form.Item label="Approved" name="is_approved">
                <Switch defaultChecked={false} />
              </Form.Item>
            </div>
            {/* Item */}
            <div className="col-lg-12">
              <ImagesUploadComponent
                onImageUpload={handleImageUpload}
                imageList={imageList}
                setImageList={setImageList}
                storagePath={"listings"}
              />
            </div>
          </div>
        </div>
        <div className="row mt-5 pt-2">
          <div className="col-lg-4 offset-lg-4">
            <Form.Item
              wrapperCol={{
                offset: 1,
                span: 16,
              }}
            >
              <Button
                loading={loading}
                size="large"
                block
                type="primary"
                htmlType="submit"
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddListings;
